import React from 'react';
import styled from '@emotion/styled';
import SecondaryButton from '../../../../atoms/buttons/SecondaryButton';
import RoundCheckIcon from '../../../../atoms/icons/RoundCheckIcon';
import { IProps } from './types/DashboardDiscoverModeGotItButton';
import breakpoints from '../../../../theme/material/breakpoints';

const DashboardDiscoverModeGotItButtonWrapper = styled(SecondaryButton)({
  [breakpoints.down('sm')]: {
    width: 'inherit',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 50,
  },
  [breakpoints.up(769)]: {
    width: 'inherit',
    margin: '0 auto',
    padding: '16px 32px',
    height: '51px',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 0,
  },
});

const RoundCheckIconWrapper = styled(RoundCheckIcon)(() => ({
  [breakpoints.down('sm')]: {
    width: 13,
    height: 13,
  },
  [breakpoints.up(769)]: {
    width: 19,
    height: 19,
  },
}));

const DashboardDiscoverModeGotItButton: React.FC<IProps> = ({ onConfirm, customStyle }: IProps) => {
  return (
    <DashboardDiscoverModeGotItButtonWrapper
      size="x-small"
      color="red"
      onClick={onConfirm}
      data-test-id="dashboard-swipe-mode-got-it"
      label="Got It!"
      customStyle={customStyle}
      withIcon={
        <RoundCheckIconWrapper
          customStyle={{
            marginRight: 6,
          }}
          customFill={'#E21D4A'}
        />
      }
    />
  );
};

export default DashboardDiscoverModeGotItButton;
